import React from 'react';
import {Typography} from '@bonprix/design-system';
import {SearchTagList} from './SearchTagList.jsx';
import {SearchTrinityEvents} from '../../helper/search-tracking.js';
import {capitalizeWords} from '../../helper/text-case.js';
import {FOCUS_VISIBLE_RING_CLASSES} from '../hooks/use-keyboard-focus.js';

const MAX_POPULAR = 10;

const CHIP_CLASS =
    'flex items-center border border-solid border-clr-on-bg-high bg-transparent px-3 py-1.5 ' +
    'max-w-full text-left text-sm text-clr-on-bg-high cursor-pointer [@media(hover:hover)]:hover:underline ' +
    FOCUS_VISIBLE_RING_CLASSES;

/**
 * Popular searches shown in the empty overlay state as bordered "search tags" — only when there are no
 * recent searches. Differences from RecentSearches: no icon, clicking a term searches immediately, no
 * delete. Layout (2-row collapse + "mehr/weniger anzeigen" toggle) is shared via {@link SearchTagList}.
 */
export const PopularSearches = ({popularSearches, header, showMoreLabel, showLessLabel, onSelectTerm}) => {
    const terms = (popularSearches || []).slice(0, MAX_POPULAR);

    const handleTermClick = (term, index) => {
        SearchTrinityEvents.sendSearchPopularSearchesAction('clickPopularSearchTerm', term, index);
        onSelectTerm(term);
    };

    const handleToggleExpanded = (expanded) => {
        SearchTrinityEvents.sendSearchPopularSearchesAction(
            expanded ? 'showMorePopularSearches' : 'showLessPopularSearches',
        );
    };

    return (
        <SearchTagList
            terms={terms}
            showMoreLabel={showMoreLabel}
            showLessLabel={showLessLabel}
            onToggleExpanded={handleToggleExpanded}
            header={
                <div className="mb-2">
                    <Typography variant="h6" component="span" className="text-clr-on-bg-mid">
                        {header || 'Beliebte Suchen'}
                    </Typography>
                </div>
            }
            renderChip={(term, isHidden, index) => (
                <button
                    type="button"
                    className={CHIP_CLASS}
                    tabIndex={isHidden ? -1 : 0}
                    onClick={() => handleTermClick(term, index)}
                    onMouseDown={(e) => e.preventDefault()}
                >
                    {capitalizeWords(term)}
                </button>
            )}
        />
    );
};
